import { defaultLanguage } from "../../../constants/languages";
import { InputForm } from "./Form";

export default function StepOne({
  setStep,
  config,
  language,
  handleVerificationRequest,
  handleCarrierCode,
}) {
  return (
    <>
      <div className="w-full flex justify-center items-center lg:min-h-[300px]">
        <InputForm
          setStep={setStep}
          config={config}
          language={language}
          popUpText={
            config.texts?.[language || defaultLanguage]?.[0]?.description || ""
          }
          handleVerificationRequest={handleVerificationRequest}
          handleCarrierCode={handleCarrierCode}
        />
      </div>
    </>
  );
}
